/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import BaseController from "de/realcore/realseats/controller/BaseController";
import Event from "sap/ui/base/Event";
import NavigationListItem from "sap/tnt/NavigationListItem";
import ToolPage from "sap/tnt/ToolPage";
import JSONModel from "sap/ui/model/json/JSONModel";
import ManagedObject from "sap/ui/base/ManagedObject";
import NavigationList from "sap/tnt/NavigationList";

/**
 * @namespace de.realcore.realseats.controller
 */
export default class App extends BaseController {
    /*eslint-disable @typescript-eslint/no-empty-function*/
    public onInit(): void {
        // Load version from manifest
        const oManifest = this.getOwnerComponent().getManifestObject();
        const sVersion = oManifest.getEntry("/sap.app/applicationVersion/version") as string;
        const oVersionModel = new JSONModel({ version: sVersion });
        this.getView().setModel(oVersionModel, "version");

        this.getOwnerComponent()
            .getEventBus()
            .subscribe(
                "App",
                "SetNavigationListItemSelected",
                (sChannelId: string, sEventId: string, oData: object) => {
                    const sKey = (oData as { Key: string }).Key;
                    const bNavigationItemFound = this.getView()
                        .byId("idNavigationList")
                        .findAggregatedObjects(true, (oElement: ManagedObject) => {
                            if (
                                oElement instanceof NavigationListItem &&
                                oElement.getKey() === sKey
                            ) {
                                return true;
                            }
                            return false;
                        });
                    if (bNavigationItemFound) {
                        (this.getView().byId("idNavigationList") as NavigationList).setSelectedKey(
                            sKey
                        );
                    }
                }
            );
    }

    /**
     * checks the current localstorage theme item, if it is dark it
     * should run the function to toggle the dark mode, if not the execution
     * should be stopped.
     *
     * TODO: add this as a setting inside the db instead of the localstorage
     *
     * @returns {void | undefined}
     */
    public onAfterRendering(): void | undefined {
        this.displayUserName().catch((error) => {
            console.error("Error displaying user name:", error);
        });
        const theme = localStorage.getItem("theme") || "";

        if (theme !== "sap_horizon_dark") {
            return;
        }

        this.onButtonToggleDarkModePress();
    }

    public async displayUserName(): Promise<void> {
        const user = await this.getOwnerComponent().getCurrentUser();
        this.getView().setModel(new JSONModel(user), "user");
    }

    public onNavItemSelect(oEvent: Event): void {
        const oItem = oEvent.getParameter(
            "item" as keyof typeof oEvent.getParameter
        ) as NavigationListItem;
        if (oItem) {
            const sKey = oItem.getKey();
            if (sKey) {
                if (this.getView().getModel("oRealSeats").getProperty("/isMobile")) {
                    (this.getView().byId("idToolPage") as ToolPage).setSideExpanded(false);
                }
                this.navTo(sKey);
            } else {
                console.warn(`Navigation key ${sKey} not recognized.`);
            }
        }
    }
    public onMenuButtonPress(): void {
        (this.getView().byId("idToolPage") as ToolPage).setSideExpanded(
            !(this.getView().byId("idToolPage") as ToolPage).getSideExpanded()
        );
    }

    public onItemSelect(oEvent: Event): void {
        const oItem = oEvent.getParameter(
            "item" as keyof typeof oEvent.getParameter
        ) as NavigationListItem;
        if (oItem) {
            const sKey = oItem.getKey();
            if (sKey === "ReportBug") {
                this.onBug();
            }
        }
    }
}
